var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentsHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sentiments=Happy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 152C119.703 152 152 119.701 152 80C152 40.2992 119.703 8 80 8C40.2969 8 8 40.2992 8 80C8 119.701 40.2969 152 80 152ZM80 17.6C114.406 17.6 142.4 45.5914 142.4 80C142.4 114.409 114.406 142.4 80 142.4C45.5937 142.4 17.6 114.409 17.6 80C17.6 45.5914 45.5937 17.6 80 17.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4437 65.314C65.1734 62.9913 62.2531 62.1382 59.9281 63.4132C57.6031 64.6882 56.75 67.6062 58.025 69.9312C62.3234 77.7687 70.6765 82.639 79.8265 82.639C88.6999 82.639 96.9453 78.0312 101.342 70.6132C102.692 68.3327 101.942 65.389 99.6593 64.0366C97.3765 62.6843 94.4327 63.4413 93.0827 65.7195C90.4062 70.2335 85.3296 73.039 79.8265 73.039C74.1828 73.039 69.0547 70.0789 66.4437 65.314ZM46.4 53.5999C49.0531 53.5999 51.2 51.4507 51.2 48.7999C51.2 44.8296 54.4296 41.5999 58.4 41.5999C62.3703 41.5999 65.6 44.8296 65.6 48.7999C65.6 51.4507 67.7468 53.5999 70.4 53.5999C73.0531 53.5999 75.2 51.4507 75.2 48.7999C75.2 39.5374 67.6625 31.9999 58.4 31.9999C49.1374 31.9999 41.6 39.5374 41.6 48.7999C41.6 51.4507 43.7468 53.5999 46.4 53.5999ZM89.6 53.5999C92.2531 53.5999 94.4 51.4507 94.4 48.7999C94.4 44.8296 97.6296 41.5999 101.6 41.5999C105.57 41.5999 108.8 44.8296 108.8 48.7999C108.8 51.4507 110.947 53.5999 113.6 53.5999C116.253 53.5999 118.4 51.4507 118.4 48.7999C118.4 39.5374 110.862 31.9999 101.6 31.9999C92.3374 31.9999 84.8 39.5374 84.8 48.7999C84.8 51.4507 86.9469 53.5999 89.6 53.5999Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentsHappy);
export default __webpack_public_path__ + "static/media/SentimentsHappy.c5d746c49538423a0b0e94c846c94017.svg";
export { ForwardRef as ReactComponent };